var _rect, _rect2, _path, _path2, _line, _rect3, _path3, _rect4, _g, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2FactorAuthenticationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_2F_32",
    "data-name": "2F_32",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1224",
    "data-name": "Rectangle 1224",
    width: 30,
    height: 30,
    transform: "translate(1 1)",
    fill: "#fff",
    opacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    d: "M23.05,4.97h.76a1.668,1.668,0,0,1,1.8,1.52V8.43",
    fill: "none",
    stroke: "#f88c14",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_577-2",
    d: "M20.07,21.06H5.23a1.662,1.662,0,0,1-1.8-1.52V6.64A1.664,1.664,0,0,1,5.09,4.97H18.62",
    fill: "none",
    stroke: "#f88c14",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_116",
    x2: 18.17,
    transform: "translate(1.76 21.89)",
    fill: "none",
    stroke: "#f88c14",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_622",
    width: 9.99,
    height: 18.84,
    rx: 1.32,
    transform: "translate(20.07 8.72)",
    fill: "none",
    stroke: "#f88c14",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    d: "M16.37,11.34l-3.79,3.79L10.85,13.4",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680-2",
    width: 30.18,
    height: 30.18,
    transform: "translate(0.82 1.19)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3303",
    "data-name": "Group 3303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    d: "M26.49,17.02V16.01a1.181,1.181,0,0,0-1.32-.85,1.1,1.1,0,0,0-1.14.85v1.01",
    fill: "none",
    stroke: "#fc4c85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1208",
    d: "M23.48,17.31h3.56a.386.386,0,0,1,.42.34v2.58a.386.386,0,0,1-.42.34H23.48a.386.386,0,0,1-.42-.34V17.65A.386.386,0,0,1,23.48,17.31Z",
    fill: "none",
    stroke: "#fc4c85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(20.33 4.4)",
    fill: "#f88c14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2FactorAuthenticationIcon);
export default __webpack_public_path__ + "static/media/2-factor-authentication-icon.52d9c857545c58528d3bd38caae9c53c.svg";
export { ForwardRef as ReactComponent };